import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitLead = async (payload) => {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
};

export const fetchLeads = async (token) => {
  const { data } = await axios.get(`${API}/leads`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const fetchLeadStats = async (token) => {
  const { data } = await axios.get(`${API}/leads/stats`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};
